<template>
    <div ref="content">
        <div class="menu_top padding_bottom_64">
            
            <div class="cart_suggesttitle margin_top_32 display_flex  justify-content_flex-justify"><span>{{$t('order.ordertail')}}</span></div>
            <div class="cartbox display_flex   orderdetailbox">
                <span class="padding_right_32">{{$t('personal.orderNo')}}：{{orderNo}}</span>
                <span >{{$t('order.order_creattime')}}：{{formatTimefun(orderdetaildata.ctime)}}</span>
            </div>
            <div class="cartbox display_flex background_none">
                <span class="width_794" style="padding-left:32px;box-sizing:border-box">{{$t('order.orderinfo')}}</span>
                <span class="width_203 textalign_center">{{$t('order.price')}}</span>
                <span class="width_203 textalign_center">{{$t('order.orderocaozuo')}}</span>
            </div>
            <div>
                <div  class="textalign_left border">
                    <div class="cartlist" >
                        <div class=" display_flex  justify-content_flex-justify align-items_center">
                          
                            <table class="person_cartlist_Item_R display_flex align-items_center">
                                <tr>
                                    <td class="width_794">
                                        <div class="person_order_Each" v-for="item in orderdetaildata.prdList" @click="todetail(item)">
                                            <div class="roundType">{{rank_type[item.prdType]}}</div>
                                            <div class="carttitle">
                                                {{item.title}}
                                            </div>
                                        </div>
                                    </td>
                                    <td class="width_203 red">¥ {{orderdetaildata.totalPrice}}</td>
                                    <td class="width_203">{{orderstatus[orderdetaildata.status]}}</td>
                                    
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="order_text textalign_right">
                <div>{{$t('order.pay_money')}}： <span class="orderdetail_price">¥ {{orderdetaildata.totalPrice}}</span></div>
                
            </div>
            <div class="textalign_right" v-if="orderdetaildata.status == '0'">
                <div class="orderdetail_paybtn" @click="payagain(orderdetaildata)">{{$t('personal.paynow')}}</div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}


// 购物车
.cart_suggesttitle {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    text-align: left;
    padding: 32px 0;
    box-sizing: border-box;

    .lookall {
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #262633;
    }
}

.padding_left_394 {
    padding-left: 394px;
    box-sizing: border-box;
}

.padding_left_430 {
    padding-left: 430px;
    box-sizing: border-box;
}

.padding_left_72 {
    padding-left: 72px;
    box-sizing: border-box;
}

.padding_left_24 {
    padding-left: 24px;
    box-sizing: border-box;
}

.padding_left_16 {
    padding-left: 16px;
    box-sizing: border-box;
}

.padding_left_70 {
    padding-left: 70px;
    box-sizing: border-box;
}

.padding_left_32 {
    padding-left: 32px;
    box-sizing: border-box;
}

.margin_top_32 {
    margin-top: 32px;
}

.padding_top_32 {
    padding-top: 32px;
    box-sizing: border-box;
}

.padding_left_280 {
    padding-left: 280px;
    box-sizing: border-box;
}

.padding_left_162 {
    padding-left: 162px;
    box-sizing: border-box;
}

.padding_left_366 {
    padding-left: 366px;
    box-sizing: border-box;
}

.margin_top_40 {
    margin-top: 40px;
    box-sizing: border-box;
}

.margin_bottom_32{
    margin-bottom:32px;
}

.padding_right_16 {
    padding-right: 16px;
    box-sizing: border-box;
}
.padding_right_28{
    padding-right:28px;
    box-sizing: border-box;
}
.icon_round {
    width: 24px;
    height: 24px;
    border: 1px solid #D5D5D7;
    border-radius: 50%;
}

.cartbox {
    height: 64px;
    line-height: 64px;
    background: #F8FBFD;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    text-align: left;
    padding-left: 24px;
    box-sizing: border-box;
    &.orderdetailbox{
        padding:0 234px 0 32px;
        box-sizing: border-box;
    }
    &.orderdetailbox1{
        padding:0 234px 0 32px;
        box-sizing: border-box;
        background: none;
    }
    .totalprice {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FF7467;
        margin-left: 30px;
    }

    .paybtn {
        width: 180px;
        height: 100%;
        line-height: 64px;
        background: #60DEB4;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        display: inline-block;
        margin-left: 40px;
        vertical-align: top;
    }
}

.cartlist {

    .cartlist_Item {
        margin-top: 24px;

    }
    .checkrank{
        width: 144px;
        height: 36px;
        line-height: 36px;
        background: #60DEB4;
        border-radius: 18px;
        color:#fff;
        text-align: center;
        margin-bottom: 16px;
        cursor: pointer;
        &:hover{
            background: -webkit-linear-gradient(right, #28D877 0%, #0DC6B8 100%);
            background: -o-linear-gradient(right, #28D877 0%, #0DC6B8 100%);
            background: linear-gradient(to left, #28D877 0%, #0DC6B8 100%);
        }
    }
    // .person_cartlist_Item_R {
    //     width: 100%;
    //     background: #FFFFFF;
    //     padding: 24px 0 24px 24px;
    //     box-sizing: border-box;
    //     .person_order_Each{
    //         padding-bottom: 24px;
    //         box-sizing: border-box;
    //     }

    //     .roundType {
    //         width: 72px;
    //         height: 72px;
    //         line-height: 72px;
    //         color: #fff;
    //         border-radius: 50%;
    //         background-color: #60DEB4;
    //         font-size: 24px;
    //         font-family: PingFangSC-Medium, PingFang SC;
    //         font-weight: 500;
    //         text-align: center;
    //     }

    //     .carttitle {
    //         width: 650px;
    //         margin-right:  80px;
    //         margin-left: 24px;
    //         text-align: left;

    //         .title {
    //             font-size: 24px;
    //             font-family: PingFangSC-Medium, PingFang SC;
    //             font-weight: 500;
    //             color: #262633;
    //             line-height: 36px;
    //             @include linelimt(1);
    //         }

    //         .desc {
    //             font-size: 14px;
    //             font-family: PingFangSC-Regular, PingFang SC;
    //             font-weight: 400;
    //             color: #888888;
    //             line-height: 24px;
    //             @include linelimt(1);
    //             margin-top: 4px;
    //         }
    //     }

    //     .price {
    //         font-size: 18px;
    //         font-family: PingFangSC-Regular, PingFang SC;
    //         font-weight: 400;
    //         color: #FF7467;
    //         padding-left: 78px;
    //         box-sizing: border-box;
    //     }

    //     .delbtn {
    //         font-size: 14px;
    //         font-family: PingFangSC-Regular, PingFang SC;
    //         font-weight: 400;
    //         color: #51515C;
    //         text-align: center;
    //     }
    // }
    .person_cartlist_Item_R {
        width: 100%;
        background: #FFFFFF;
        // border: 1px solid #F4F4F5;
        padding: 24px 0 24px 24px;
        box-sizing: border-box;
        
        .person_order_Each{
            padding-bottom: 24px;
            box-sizing: border-box;
            cursor: pointer;
            &:last-child{
                padding-bottom: 0;
            }
        }
        .width_203{
            font-size: 16px;
            font-family: 'PingFang SC';
            font-weight: 400;
            color: #51515C;
            line-height: 16px;
            text-align: center;
            border-left:1px solid #F4F4F5;
            box-sizing: border-box;
            &.red{
                color: #FF7467;
            }
        }

        .roundType {
            width: 72px;
            height: 72px;
            line-height: 72px;
            color: #fff;
            border-radius: 50%;
            background-color: #60DEB4;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            text-align: center;
            display: inline-block;
            vertical-align: middle;
        }

        .carttitle {
            width: 385px;
            margin-right:  80px;
            margin-left: 24px;
            text-align: left;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #262633;
            line-height: 36px;
            @include linelimt(1);
            display: inline-block;
            vertical-align: middle;
            .title {
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #262633;
                line-height: 36px;
                @include linelimt(1);
            }

            .desc {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #888888;
                line-height: 24px;
                @include linelimt(1);
                margin-top: 4px;
            }
        }

        .price {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FF7467;
            padding-left: 78px;
            box-sizing: border-box;
        }

        .delbtn {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
            text-align: center;
        }
    }
}

// 个人中心
.person_info {
    width: 100%;
    height: 240px;
    position: relative;
    background: #F8FBFD;
    padding: 64px 0 0 64px;
    box-sizing: border-box;

    .headImg {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 2px solid #fff;
        margin-right: 60px;
        background: #678;

    }

    .edit_btn {
        width: 144px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 18px;
        border: 1px solid #60DEB4;
        position: absolute;
        right: 32px;
        top: 32px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #60DEB4;
        cursor: pointer;

    }

    .info_detail {
        text-align: left;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;

        .nickname {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #51515C;
            line-height: 28px;
            padding-bottom: 10px;
            box-sizing: border-box;
        }

        .info_left {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #A8A8AD;
            line-height: 28px;
            padding-right: 16px;
            box-sizing: border-box;
        }

        .info_right {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
            line-height: 28px;
        }
    }
}

.person_order_box {
    height: 40px;
    line-height: 40px;
    background: #F8FBFD;
    text-align: left;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    display: inline-block;
    padding-right: 20px;
}

.cursor{
    cursor: pointer;
}

.padding_right_32{
    padding-right: 32px;
}
.border{
    border:1px solid #F4F4F5;
}
.width_794{
    width: 794px;
}

.width_610{
    width: 610px;
}
.width_203{
    width:203px;
}

.background_none{
    background: none;
}

.order_text{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    padding:32px 42px  36px 0;
    box-sizing: border-box;
    line-height:24px;
    text-align: right;
}

.orderdetail_price{
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FF7467;
    padding-left:30px;
    box-sizing: border-box;
}

.orderdetail_paybtn{
    width: 256px;
    height: 64px;
    line-height:64px;
    text-align: center;
    background: #60DEB4;
    border-radius: 32px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: inline-block;
    cursor: pointer;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import {myMixin} from '@/mixin/mixin.js'
import { orderdetailApi } from '@/api/api.js'
import {formatTime} from '@/utils/other.js'
export default {
    name: '',
    components: {
        banner,
    },
    mixins:[myMixin],
    data() {
        return {
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination1'
                },
                uniqueNavElements: false,

                // Some Swiper option/callback...
            },
            orderdetaildata:{}
        }
    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        },
        orderNo(){
            return this.$route.query.orderNo
        },
        formatTimefun(){
            return function(ctime){
                if(ctime>0){
                    return formatTime(ctime,'Y-M-D h:m')
                }
                
            }
        }
    },
    watch:{
        'orderdetaildata':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
            })
        }
    },
    mounted() {
        this.orderdetail()
    },
    methods: {
        orderdetail(){
            orderdetailApi({
                orderNo: this.$route.query.orderNo,
                lang:window.localStorage.getItem("LOCALE") ||  'chs'
            }).then(res => {
                if (res.code == 200) {
                    this.orderdetaildata = res.data
                } else if(res.code == 400){
                    this.$router.push({
                        path: '/Page404'
                    })
                }else {
                    this.toast(res.message)
                    

                }
            })
        },
        todetail(item){
            switch(item.prdType){
                case '1':
                    if(item.urlPc){
                        
                        window.location.href = item.urlPc
                        
                    }else{
                        this.gorouter('/rank/detail/'+item.prdId)
                    }
                    
                break;
                case '2':
                    this.gorouter('/report/detail/'+item.prdId)
                break;
            }
            
        },
        // 二次支付入口  
        payagain(item){
            console.log(item)
            window.sessionStorage.setItem('orderlist',JSON.stringify(item.prdList));
            this.$router.push({
                path:'/pay',
                query:{
                    paytype:2,  //再次支付标识
                    orderNo:item.orderNo,
                    totalPrice:item.totalPrice
                }
            })
            
        },

    }
}
</script>